import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex w-full divide-x divide-ternary rounded-xl bg-[#FDFDFD]" }
const _hoisted_2 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_3 = { class: "text-base leading-[20px]" }
const _hoisted_4 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_5 = { class: "text-base leading-[20px]" }
const _hoisted_6 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_7 = { class: "text-base leading-[20px]" }
const _hoisted_8 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_9 = { class: "text-base leading-[20px]" }
const _hoisted_10 = { class: "font-semibold text-2xl text-black" }
const _hoisted_11 = { class: "flex flex-col gap-6 h-full overflow-y-auto bg-white rounded-lg p-4" }
const _hoisted_12 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_13 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_14 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_15 = { class: "flex flex-col gap-4" }
const _hoisted_16 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_17 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_18 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_19 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_20 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_21 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_22 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_23 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_24 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_25 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_26 = { class: "text-left text-base leading-[20px] text-brown" }

import { computed, ref } from "vue";
import { Hidden } from "@/types/calculators";
import { ownerOrder } from "@/constants/bazi";
import { useI18n } from "vue-i18n";
import ModalComponent from "@/components/ModalComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NatalHiddenMobile',
  props: {
    hidden: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const hiddenType = ref<"hour" | "day" | "month" | "year" | null>(null);

const groupedHidden = computed(() => {
  const result: Record<string, Hidden[]> = {};
  for (const owner of ownerOrder) {
    const items = props.hidden.filter((h) => h.owner === owner);
    if (items.length > 0) {
      result[owner] = items;
    }
  }
  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (hiddenType.value = 'hour'))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(groupedHidden.value["hour"][0].stem), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.hour")), 1)
    ]),
    _createElementVNode("div", {
      class: "flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (hiddenType.value = 'day'))
    }, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(groupedHidden.value["day"][0].stem), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.day")), 1)
    ]),
    _createElementVNode("div", {
      class: "flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (hiddenType.value = 'month'))
    }, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(groupedHidden.value["month"][0].stem), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.month")), 1)
    ]),
    _createElementVNode("div", {
      class: "flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (hiddenType.value = 'year'))
    }, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(groupedHidden.value["year"][0].stem), 1),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.year")), 1)
    ]),
    _createVNode(ModalComponent, {
      show: hiddenType.value !== null,
      variant: "fullscreen",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (hiddenType.value = null)),
      "container-class": "bg-beige"
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)(`calculators.bazi.modal.hidden.title.${hiddenType.value}`)), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedHidden.value[hiddenType.value], ({ stem, labels, tips }, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx + hiddenType.value + 'stem',
              class: "flex flex-col gap-4"
            }, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(stem) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.heaven-stem")), 1),
              _createElementVNode("h5", _hoisted_13, _toDisplayString(labels.stem), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(tips.stem), 1)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(groupedHidden.value[hiddenType.value][0].branch) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.earth-branch")), 1),
            _createElementVNode("h5", _hoisted_17, _toDisplayString(groupedHidden.value[hiddenType.value][0].labels.branch), 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(groupedHidden.value[hiddenType.value][0].tips.stem), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedHidden.value[hiddenType.value], ({ stage, labels, tips }, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx + hiddenType.value + 'stage',
              class: "flex flex-col gap-4"
            }, [
              _createElementVNode("p", _hoisted_19, _toDisplayString(stage) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.stage")), 1),
              _createElementVNode("h5", _hoisted_20, _toDisplayString(labels.stage), 1),
              _createElementVNode("p", _hoisted_21, _toDisplayString(tips.stage), 1)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedHidden.value[hiddenType.value], ({ element, tips }, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx + hiddenType.value + 'element',
              class: "flex flex-col gap-4"
            }, [
              _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)(`calculators.bazi.modal.hidden.element.${element}`)), 1),
              _createElementVNode("p", _hoisted_23, _toDisplayString(tips.element), 1)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedHidden.value[hiddenType.value], ({ god, labels, tips }, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx + hiddenType.value + 'god',
              class: "flex flex-col gap-4"
            }, [
              _createElementVNode("p", _hoisted_24, _toDisplayString(god) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.god")), 1),
              _createElementVNode("h5", _hoisted_25, _toDisplayString(labels.god), 1),
              _createElementVNode("p", _hoisted_26, _toDisplayString(tips.god), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})